import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { Chips } from '@carnica/ui-kit';
import classNames from 'classnames/bind';
import { IconSendFilled } from '@carnica/graphics';
import { changeRegion } from "../../../../api/region";
import { Metric } from "../../../../metric";
import style from "./styles.pcss";
var cn = classNames.bind(style);
export var PopularRegions = function PopularRegions(_ref) {
  var popularRegions = _ref.popularRegions;
  return /*#__PURE__*/React.createElement("ul", {
    className: cn('popular-regions')
  }, popularRegions === null || popularRegions === void 0 ? void 0 : popularRegions.map(function (region, index) {
    return /*#__PURE__*/React.createElement(Metric, {
      asChild: true,
      data: region.title,
      events: {
        headerMetric: ['handleChosenRegionClick']
      },
      key: region.title,
      mode: "click"
    }, /*#__PURE__*/React.createElement(Chips, {
      className: cn('chips'),
      color: "dark",
      iconLeft: index === 0 ? IconSendFilled : undefined,
      invert: true,
      label: region.title,
      onClick: function onClick() {
        return changeRegion(_objectSpread(_objectSpread({}, region), {}, {
          id: region.code
        }));
      }
    }));
  }));
};